export default "__VITE_ASSET__BMnyQtMZ__"